import _ from 'underscore';
import config from '@bingads-webui-component-legacy/config/index';
import { OldHeadersMap } from '@bingads-webui-campaign-legacy/adextension-structuredsnippet/model/model';
import { globalizationModelSetup } from '@bingads-webui-campaign/ads-globalization';

const { LANGUAGES } = globalizationModelSetup({
  permissions: config.get('permissions'),
  culture: config.get('culture'),
});

export const selectOptions = _.map(LANGUAGES, (lang) => [
  lang,
  _.map(OldHeadersMap[lang], ([header]) => header),
]);
